export interface FirebaseConfigEnv {
  REACT_APP_FIREBASE_API_KEY?: string;
  REACT_APP_FIREBASE_AUTH_DOMAIN?: string;
  REACT_APP_FIREBASE_PROJECT_ID?: string;
  REACT_APP_FIREBASE_STORAGE_BUCKET?: string;
  REACT_APP_FIREBASE_MESSAGING_SENDER_ID?: string;
  REACT_APP_FIREBASE_APP_ID?: string;
  REACT_APP_FIREBASE_MEASUREMENT_ID?: string;
  [key: string]: string | undefined;
}

function defaultAuthDomain(projectId?: string): string | undefined {
  return projectId ? `${projectId}.firebaseapp.com` : undefined;
}

const CANONICAL_AUTH_DOMAINS: Record<string, string> = {
  'aligned-crm-app': 'aligned-crm-app.firebaseapp.com',
};

export function resolveAuthDomain(
  configuredAuthDomain: string | undefined,
  projectId: string | undefined,
  hostname: string | undefined,
): string | undefined {
  if (!hostname || hostname === 'localhost' || hostname === '127.0.0.1') {
    return configuredAuthDomain ?? defaultAuthDomain(projectId);
  }

  if (projectId && CANONICAL_AUTH_DOMAINS[projectId]) {
    return CANONICAL_AUTH_DOMAINS[projectId];
  }

  return configuredAuthDomain ?? defaultAuthDomain(projectId);
}

export function buildFirebaseConfig(
  env: FirebaseConfigEnv,
  hostname: string | undefined,
) {
  return {
    apiKey: env.REACT_APP_FIREBASE_API_KEY,
    authDomain: resolveAuthDomain(
      env.REACT_APP_FIREBASE_AUTH_DOMAIN,
      env.REACT_APP_FIREBASE_PROJECT_ID,
      hostname,
    ),
    projectId: env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: env.REACT_APP_FIREBASE_APP_ID,
    measurementId: env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  };
}
